export default (...args: string[]) =>
  args
    .join(' ')
    .trim()
    .toLowerCase()
    .replace(/\s/g, '-');
